import { render } from "./HistCanalCell.vue?vue&type=template&id=ad710330&scoped=true"
import script from "./HistCanalCell.vue?vue&type=script&lang=js"
export * from "./HistCanalCell.vue?vue&type=script&lang=js"

import "./HistCanalCell.vue?vue&type=style&index=0&id=ad710330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad710330"]])

export default __exports__